import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useState, useEffect } from 'react';
import { Typography, Tooltip } from '@mui/material';
import { observer } from 'mobx-react-lite';
const ItemTitle = ({ title }) => {
    const textElementRef = useRef(null);
    const [hoverStatus, setHover] = useState(false);
    const compareSize = () => {
        if (textElementRef.current?.scrollHeight && textElementRef.current?.clientHeight) {
            const compare = textElementRef.current?.scrollHeight > textElementRef.current?.clientHeight;
            setHover(compare);
        }
    };
    // compare once and add resize listener on "componentDidMount"
    useEffect(() => {
        compareSize();
        window.addEventListener('resize', compareSize);
    }, []);
    // remove resize listener again on "componentWillUnmount"
    useEffect(() => () => {
        window.removeEventListener('resize', compareSize);
    }, []);
    if (!title) {
        return null;
    }
    return (_jsx(Tooltip, { title: title, disableHoverListener: !hoverStatus, children: _jsx(Typography, { variant: "subtitle1", noWrap: true, ref: textElementRef, sx: {
                lineHeight: 1.5,
                color: 'greyCustom[800]',
                height: '3em',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: '2',
                WebkitBoxOrient: 'vertical',
                whiteSpace: 'normal',
            }, className: "courseTitleSalesCard", component: "div", children: title }) }));
};
export default observer(ItemTitle);
//# sourceMappingURL=ItemTitle.js.map